import { DateTime } from "luxon";
export function DateHelper() {
  this.getDefaultDate = function getDefaultDate() {
    return new Date(DateTime.local().ts);
  };

  this.getMoment = function getMoment() {
    return DateTime.local();
  };

  this.getDisableDates = function getDisableDates() {
    return { to: new Date(DateTime.local().minus({ day: 1 }).ts) };
  };

  this.getDateTimeMoment = function getDateTimeMoment(date, time) {
    var dateTime = convertToDateTime(date, time);
    return dateTime;
  };

  this.fullDateTimeFormat = function fullDateTimeFormat(date, time, format) {
    var dateTime = convertToDateTime(date, time).toFormat(format);
    return dateTime;
  };

  this.addMinutesFullDateTimeFormat = function addMinutesFullDateTimeFormat(
    date,
    time,
    format,
    min
  ) {
    var dateTime = convertToDateTime(date, time)
      .plus({ minute: min })
      .toFormat(format);
    return dateTime;
  };

  this.getShortDateFormat = function getShortDateFormat(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  };

  this.addMinutesToTime = function addMinutesToTime(time, min, format) {
    return this.getMomentOfTime(time)
      .plus({ minute: min })
      .toFormat(format);
  };

  this.addDate = function addDate(date, dayCount) {
    var dateTime = new Date(
      DateTime.fromJSDate(new Date(date)).plus({ day: dayCount })
    );
    return dateTime;
  };

  this.getMomentOfTime = function getMomentOfTime(time) {
    var dateTime = convertToDateTime(DateTime.local(), time);
    return dateTime;
  };
}
export function convertToDateTime(date, time) {
  var timeArray = time.split(":");
  var minute = timeArray[1].split(" ")[0];
  var hour;
  if (time.indexOf("PM") != -1) {
    hour =
      parseInt(timeArray[0]) === 12
        ? parseInt(timeArray[0])
        : parseInt(timeArray[0]) + 12;
  } else hour = timeArray[0];

  var jsDate = new Date(date);
  var dateTime = DateTime.fromJSDate(
    new Date(
      jsDate.getUTCFullYear(),
      jsDate.getMonth(),
      jsDate.getDate(),
      hour.toString(), //hour
      minute, //minute
      0,
      0
    )
  );
  return dateTime;
}
export const dateHelper = new DateHelper();
